import client from '../httpClient';

const smsHistoryApi = (customerId) => {
  return client.get(`/sms/history/${customerId}`);
};

export default smsHistoryApi;
